<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="gridOptions.columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers" style="flex:none">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button no="back" type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button no="Edit" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
                  <!--打印-->
                  <el-button no="print" :disabled="isEditing" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                </div>
                <div v-show="isNew || action==='edit'" class="new" style="border-left:none;padding-left:0">
                  <el-button no="save" type="success" @click="save(false)">{{ $t('common.btn.save') }}</el-button>
                  <!--保存并入仓完成-->
                  <el-button no="saveDone" type="success" @click="saveDoneHandler()">{{ $t('CargoMsg.Cargo_SaveDone') }}</el-button>
                  <el-button no="cancel" type="success" @click="cancelEdit(onRefresh)">{{ $t('common.btn.cancel') }}</el-button>
                  <!--                  <el-button no="onPrintHandler" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>-->
                </div>
              </cargo-button-group-slider>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane :label="$t('Message.Main')" :lazy="true" name="baseInfo" class="warehousingDetail">
                <warehousing-detail ref="baseInfo" :warehouse-in-uuid="currentRow.uuid" :lob="lob" :action="action" @refreshHandler="isRefreshBase = false" />
              </el-tab-pane>
              <el-tab-pane :label="$t('SeaExport.Charge')" :lazy="true" name="tabCharges">
                <tab-warehousing-charge ref="tabCharges" :warehouse-in-uuid="currentRow.uuid" :action="action" @refreshHandler="isRefreshCharge = false" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import locationImg from '@/assets/location24.png'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DropUploader from '@/components/Cargo/Common/DropUploader.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { getLoading } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider/index.vue'
import warehousingDetail from './warehousingDetail.vue'
import TabWarehousingCharge from './tabWarehousingCharge.vue'
import { saveFunc } from '@/api/warehouseIn/warehouseIn'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { TabError } from '@/utils/class/TabError'
import { getCacheListByKey, syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
export default {
  name: 'WarehousingWorkspace',
  components: {
    TabWarehousingCharge,
    warehousingDetail,
    DropUploader,
    cargoAdvanceSelect,
    cargoLeftRightResize,
    cargoUserSelect,
    CargoButtonGroupSlider
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    lob: { type: String, required: true }
  },
  data() {
    return {
      locationImg,
      URL,
      selectTypeNames: TYPE_NAMES,
      SystemConstants,
      action: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        columnDefs: [
          { headerName: this.$t('Warehouse.WarehouseNo'), field: 'warehouseNo', minWidth: 160, colId: 'warehouseNo' }
        ],
        onRowClicked: this.changeWareHouseIn
      },
      chargeDialog: {
        context: {
          modifiedData: {}
        },
        action: 'edit'
      },
      job: new AirExportJob().fillDefaultValue().getData(),
      rowData: [],
      errorList: ['LocationConfigurationError'],
      gridApi: null,
      currentRow: {},
      isRefreshBase: true,
      isRefreshCharge: true,
      activeTabName: 'baseInfo'
    }
  },
  computed: {
    user() {
      return this.$store.getters.userId
    },
    isNew() {
      return this.action === 'add'
    },
    isEditing() {
      return this.action !== 'look'
    }
  },
  async created() {
    this.refreshPage()
    this.loadConfigData()
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.activeTabName = 'baseInfo'
      this.selectedRow = selectedRow
      this.action = action
      this.rowData = rowData
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.gridApi.clearFocusedCell()
        if (!selectedRow.uuid) {
          this.currentRow = selectedRow
          await this.$refs['baseInfo'].onShow(this.action, this.isRefreshBase, selectedRow)
        } else {
          await this.onRowClicked({ data: selectedRow })
        }
      })
    },
    // 加载配置项
    loadConfigData() {
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid
        const rowKey = row.uuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          break
        }
      }
    },
    async changeWareHouseIn(event) {
      const result = event.data
      if (result) {
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onRowClicked({ data: result })
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      this.currentRow = event.data
      this.setGridSelect(this.currentRow)
      this.refreshPage()
      if (this.currentRow.jobKey) {
        this.job = new AirExportJob().fillDefaultValue().getData()
        this.job.uuid = this.currentRow.jobKey
        this.job.version = 0
      }
      this.activeTabName = 'baseInfo'
      this.handleTabClick()
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      this.$nextTick(() => {
        if (this.activeTabName === 'tabCharges') {
          this.$refs['tabCharges'].onShow(this.action, this.isRefreshCharge)
        } else {
          this.$refs[this.activeTabName].onShow(this.action, this.isRefreshBase)
        }
        this.loading.close()
      })
    },
    // 编辑
    editHandler(row) {
      if (!row) {
        row = this.currentRow
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Warehouse.ExternallyImportedDataCannotEdit'))
        return
      }
      if (row.warehouseStatus === WarehouseInState.FULLY_STORED.code) {
        this.$message.warning(this.$t('SeaExport.StoredTipFour'))
        return
      }
      this.refreshPage()
      this.onShow('edit', this.rowData, row)
    },
    // 打印
    onPrintHandler() {
      const rows = []
      rows.push(this.currentRow)
      this.$emit('print', rows)
    },
    normalizeDimension(str) {
      if (!str) return ''
      const parts = str.split(';')
      const validParts = parts.filter(p => {
        if (p === '0*0*0*0') return false
        return true
      })
      return validParts.join(';')
    },
    async save(saveDone = false) {
      await sleep(200)
      const getSubmitData = this.$refs['baseInfo'].getSubmitData()
      const { warehouseNo, warehouse, warehouseInDetailList, warehouseInDate } = { ...getSubmitData.form }
      if (this.lob === 'AE' && !warehouseInDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterActualWarehousingTime'))
        return false
      }
      if (!warehouseNo) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehousingNumber'))
        return false
      }
      if (!warehouse) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehouseName'))
        return false
      }
      if (warehouseInDetailList && warehouseInDetailList.length > 0) {
        const plMap = {}
        for (const w of warehouseInDetailList) {
          if (w.quantity === 0) {
            this.$message.warning(this.$t('Message.PleaseTheNumberOfPieces'))
            return false
          }
          w.dimension = this.normalizeDimension(w.dimension)
          w.dimensionImperial = this.normalizeDimension(w.dimensionImperial)
          if (!w.palletNo) {
            continue
          }
          const options = getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => p.uuid === w.palletNo)
          if (options && options.length > 0 && options[0].recycleType === 0) {
            continue
          }
          const value = plMap[w.palletNo]
          if (value === undefined) {
            plMap[w.palletNo] = 1
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_LocationConfigurationError'))
            return false
          }
        }
      }
      let getChargeSubmitData = null
      try {
        if (this.$refs['tabCharges']) {
          getChargeSubmitData = await this.$refs['tabCharges'].getSubmitData()
        }
      } catch (err) {
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      this.loading = getLoading()
      const params = { ...getSubmitData.form, ...getChargeSubmitData }
      // 如果不是保存并入库，jobUuid设置为空 仅记录showJobUuid 临时
      if (!saveDone) {
        params.jobKey = ''
      }
      params.check = !params.uuid
      params.saveDone = saveDone
      saveFunc(params).then(resp => {
        if (resp && resp.data === FbaJobConstants.WAREHOUSE_OP_STORED) {
          this.$message.warning(this.$t('SeaExport.StoredTipFour'))
          return
        }
        if (resp && resp.data === 'WAREHOUSE_NO EXISTS') {
          this.$confirm(this.$t('Message.WarehouseNumberAlreadyExistsContinue'), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            params.check = false
            saveFunc(params).then(resp => {
              this.saveHandler(getSubmitData, resp)
            }).finally(() => this.loading.close())
          }).finally((e) => {
            this.loading.close()
          })
        } else {
          this.saveHandler(getSubmitData, resp)
        }
      }).finally(() => this.loading.close())
    },
    saveHandler(getSubmitData, resp) {
      this.loading.close()
      if (this.errorList.includes(resp.data)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_' + resp.data))
        return
      }
      syncSpecificBasicData(basicCacheKeys.basic_data_LocationConfiguration)
      syncSpecificBasicData(basicCacheKeys.basic_data_PalletConfiguration)
      this.$message.success(this.$t('Message.SavedSuccessfully'))
      this.currentRow = getSubmitData.form
      this.currentRow.dateCreated = new Date()
      this.currentRow.uuid = resp.data
      const is = this.rowData.find(p => p.uuid === resp.data)
      // 新增一条数据
      if (!is) {
        this.rowData.push(this.currentRow)
      } else {
        // 更新原数据
        const list = []
        for (let p of this.rowData) {
          if (p.uuid === resp.data) {
            p = this.currentRow
          }
          list.push(p)
        }
        this.rowData = list
      }
      this.refreshPage()
      this.$emit('refresh', this.currentRow)
    },
    refreshPage() {
      this.isRefreshBase = true
      this.isRefreshCharge = true
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.action === 'add' && this.rowData.length === 0) {
          this.goBack()
        } else if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    goBack() {
      this.activeTabName = 'baseInfo'
      this.action = ''
      this.refreshPage()
      this.$emit('back', this.selectedRow)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 刷新
    onRefresh() {
      this.$emit('refresh', this.currentRow)
    },
    // 保存并入仓完成
    saveDoneHandler() {
      const getSubmitData = this.$refs['baseInfo'].getSubmitData()
      const { warehouseInDetailList } = { ...getSubmitData.form }

      if (!warehouseInDetailList || warehouseInDetailList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoEligibleRecord'))
        return
      }
      for (const data of warehouseInDetailList) {
        if (!data.quantity || !data.weighbridgeWeight || !data.weight || !data.storageLocation) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoEligibleRecord'))
          return
        }
      }
      this.save(true)
    }
  }
}
</script>

<style lang="scss">
.booking-details {
  .el-tabs__nav-prev,.el-tabs__nav-next{
    line-height: 29px;
  }
  .el-tabs__content{
    overflow: auto
  }
  .warehousingDetail{
    height: 100%;
  }
}
</style>
